import React  from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PageTransitionProvider } from './context/PageTransitionContext.tsx';
import Navbar from './components/navbar/navbar.tsx';
import CustomCursor from "./components/cursor/cursor.tsx";
import ScrollToTop from './components/ScrollToTop.tsx';
import ChatLauncher from './components/chat/ChatLauncher.tsx';
import Homepage from './pages/homepage.tsx';
import Chisono from './pages/chisono.tsx';
import Servizi from './pages/servizi.tsx';
import Lavori from './pages/lavori.tsx';
import Partners from './pages/partners.tsx';
import Contatti from './pages/contatti.tsx';
import Prezzi from './pages/prezzi.tsx';
import Blog from './pages/blog.tsx';
import QuantoCostaSitoWeb2025 from './pages/blog/quanto-costa-sito-web-professionale-2025.tsx';
import RestylingSitoAziendale from './pages/blog/restyling-sito-aziendale-quando-rinnovare.tsx';
import UIUXDesignFondamentale from './pages/blog/ui-ux-design-perche-fondamentale.tsx';
import ComeSceglierWebDesigner from './pages/blog/come-scegliere-web-designer-freelance.tsx';
import SitoWebRistoranti from './pages/blog/sito-web-per-ristoranti-guida-completa.tsx';
import LandingPageEfficace from './pages/blog/landing-page-efficace-come-convertire.tsx';
import AccessibilitaWebEAA from './pages/blog/accessibilita-web-european-accessibility-act.tsx';
import NextjsVsReact from './pages/blog/nextjs-vs-react-quale-scegliere.tsx';
import SeoPiccoleImprese from './pages/blog/seo-piccole-imprese-strategie.tsx';
import EcommerceArtigiani from './pages/blog/ecommerce-artigiani-piccoli-negozi.tsx';
import CMS from './pages/cms.tsx';
import Accessibilita from './pages/accessibilita.tsx';
import PrivacyPolicy from './pages/privacy-policy.tsx';
import CookiePolicy from './pages/cookie-policy.tsx';
import TrasparenzaIA from './pages/trasparenza-ia.tsx';
import NotFound from './pages/notfound.tsx';
import Footer from './components/footer/footer.tsx';
import CookieBanner from './components/cookie-banner/CookieBanner.tsx';


import './styles/global.scss';

function App() {
  return (
    <>
      <CustomCursor/>
      <ChatLauncher/>
      <div className="App" style={{ position: 'relative' }}>
        <Router>
          <PageTransitionProvider>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/chisono" element={<Chisono />} />
              <Route path="/servizi" element={<Servizi />} />
              <Route path="/lavori" element={<Lavori />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/prezzi" element={<Prezzi />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/quanto-costa-sito-web-professionale-2025" element={<QuantoCostaSitoWeb2025 />} />
              <Route path="/blog/restyling-sito-aziendale-quando-rinnovare" element={<RestylingSitoAziendale />} />
              <Route path="/blog/ui-ux-design-perche-fondamentale" element={<UIUXDesignFondamentale />} />
              <Route path="/blog/come-scegliere-web-designer-freelance" element={<ComeSceglierWebDesigner />} />
              <Route path="/blog/sito-web-per-ristoranti-guida-completa" element={<SitoWebRistoranti />} />
              <Route path="/blog/landing-page-efficace-come-convertire" element={<LandingPageEfficace />} />
              <Route path="/blog/accessibilita-web-european-accessibility-act" element={<AccessibilitaWebEAA />} />
              <Route path="/blog/nextjs-vs-react-quale-scegliere" element={<NextjsVsReact />} />
              <Route path="/blog/seo-piccole-imprese-strategie" element={<SeoPiccoleImprese />} />
              <Route path="/blog/ecommerce-artigiani-piccoli-negozi" element={<EcommerceArtigiani />} />
              {/* <Route path="/cms" element={<CMS />} /> */}
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/accessibilita" element={<Accessibilita />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/trasparenza-ia" element={<TrasparenzaIA />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
            <CookieBanner />
          </PageTransitionProvider>
        </Router>
      </div>
    </>
  );
}

export default App;